<template>
  <div>
    <el-dialog
      title="指定发货"
      :visible.sync="dialogVisible"
      width="1200px"
      :before-close="handleClose"
    >
      <div class="flex flex-spacebetween align-items mb16">
        <div>寻源商品总数：{{ skuNum }}</div>
        <div><el-button type="primary" @click="onAdd">添加包裹</el-button></div>
      </div>
      <el-table :data="data" border stripe empty-text="请先添加包裹" style="width: 100%">
        <el-table-column type="index" prop="sn" label="包裹序号" align="center" width="100" />
        <el-table-column prop="" label="包裹商品" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="onLook(scope.row)">{{ $t('viewText') }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="goodsNum" label="包裹商品数" align="center"> </el-table-column>
        <el-table-column prop="stockWarehouseCode" label="发货仓库编码" align="center">
        </el-table-column>
        <el-table-column prop="stockWarehouseName" label="指定发货仓" align="center">
        </el-table-column>
        <el-table-column prop="logisticCompanyName" label="指定物流商" align="center">
        </el-table-column>
        <el-table-column prop="logisticBusinessName" label="指定物流业务" align="center">
        </el-table-column>
        <el-table-column prop="" label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="onEdit(scope.row, scope.$index)">编辑包裹</el-button>
            <el-button type="text" @click="specifyWarehouse(scope.row, scope.$index)"
              >指定发货仓</el-button
            >
            <el-button type="text" @click="specifyLogistics(scope.row, scope.$index)"
              >指定物流</el-button
            >
            <el-button type="text" @click="onDelete(scope.row, scope.$index)">删除包裹</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="confirm">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
    <Parcel ref="parcel" :disabled="disabled" @confirm="onParcelConfirm"></Parcel>
    <AppointLogistics ref="AppointLogistics" @confirm="onLogisticsConfirm"></AppointLogistics>
    <AppointDeliveryWarehouse
      ref="warehouse"
      @confirm="onWarehouseConfirm"
    ></AppointDeliveryWarehouse>
    <PackageView ref="package"></PackageView>
  </div>
</template>

<script>
import { orderApi } from '@/api';
import Parcel from './parcel';
import AppointLogistics from './AppointLogistics.vue';
import AppointDeliveryWarehouse from './AppointDeliveryWarehouse.vue';
import PackageView from './PackageView.vue';
export default {
  name: 'BusinessOrderSourceAppointDelivery',
  components: { Parcel, AppointLogistics, AppointDeliveryWarehouse, PackageView },
  provide() {
    return {
      // 为了保证数据是动态的，所以是个函数
      orderId: () => this.orderId,
      areaCode: () => this.areaCode,
      packageData: () => this.packageData,
    };
  },
  data() {
    return {
      orderId: null,
      areaCode: null,
      objectVersionNumber: null,
      skuNum: null,
      data: [],
      packageData: {},
      dialogVisible: false,
    };
  },
  computed: {
    disabled() {
      let list = [];
      this.data.forEach(item => {
        list = [...list, ...item.goodsList.map(e => e.id)];
      });
      return list;
    },
  },

  methods: {
    show(data) {
      this.orderId = data.orderId;
      this.areaCode = data.areaCode;
      this.innerOrderSn = data.innerOrderSn;
      this.skuNum = data.skuNum;
      this.objectVersionNumber = data.objectVersionNumber;
      this.data = [];
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    onAdd() {
      this.$refs.parcel.show();
    },
    /** 查看包裹 */
    onLook(row) {
      this.$refs.package.show(row.goodsList);
    },
    onEdit(row, index) {
      this.packageData = row;
      this.index = index;
      this.$refs.parcel.show(row);
    },
    /** 指定发货仓 */
    specifyWarehouse(row, index) {
      this.packageData = row;
      this.index = index;
      this.$refs.warehouse.show(row);
    },
    /** 指定物流 */
    specifyLogistics(row, index) {
      this.packageData = row;
      this.index = index;
      this.$refs.AppointLogistics.show(row);
    },
    onDelete(row, index) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        this.data.splice(index, 1);
        this.msgSuccess(this.$t('toast.deleteSuccessText'));
      });
    },
    handleClose() {
      this.hide();
    },
    /** 保存包裹 */
    confirm() {
      if (!this.data.length) {
        this.$message.warning('请添加包裹');
        return;
      }
      let changeNum = 0;
      this.data.forEach(e => {
        changeNum += e.goodsNum;
      });
      if (changeNum != this.skuNum) {
        this.$message.warning('还有商品未分入包裹，请确认');
        return;
      }
      orderApi
        .addSourcingPackages({
          objectVersionNumber: this.objectVersionNumber,
          sourcingId: this.orderId,
          innerOrderSn: this.innerOrderSn,
          packageList: this.data,
        })
        .then(res => {
          if (!res.failed) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.hide();
            this.$emit('confirm');
          }
        });
    },
    /** 添加包裹数据回调 */
    onParcelConfirm(data) {
      const checkData = this.data.find(e => e.BJ_EBC_ID === data.BJ_EBC_ID);
      if (checkData) {
        this.data.splice(this.index, 1, data);
      } else {
        this.data.push(data);
      }
    },
    /** 添加指定物流回调 */
    onLogisticsConfirm(data) {
      const obj = this.data[this.index];
      Object.assign(obj, data);
      this.data.splice(this.index, 1, obj);
      this.msgSuccess(this.$t('toast.operationSuccessText'));
    },
    /** 添加指定发货仓数据回调 */
    onWarehouseConfirm(data) {
      const obj = this.data[this.index];
      Object.assign(obj, data);
      this.data.splice(this.index, 1, obj);
      this.msgSuccess(this.$t('toast.operationSuccessText'));
    },
  },
};
</script>

<style></style>
